import { render, staticRenderFns } from "./RecordHistoryDialog.vue?vue&type=template&id=05439701&scoped=true"
import script from "./RecordHistoryDialog.vue?vue&type=script&lang=js"
export * from "./RecordHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordHistoryDialog.vue?vue&type=style&index=0&id=05439701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05439701",
  null
  
)

export default component.exports